export default "__VITE_ASSET__BF_$EQib__"